"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const images_1 = require("../../assets/images");
const SimpleButton = ({ title, disabled = false, textStyle, onPress, style, weight, }) => {
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { disabled: disabled, onPress, style: { borderRadius: (0, scale_1.scale)(4) } },
        react_1.default.createElement(react_native_1.ImageBackground, { source: images_1.images.PrimaryButton, style: [
                {
                    height: (0, scale_1.scale)(48),
                    width: (0, scale_1.scale)(343),
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: 4,
                    overflow: "hidden",
                },
                style,
            ], borderRadius: 4, resizeMode: "cover" },
            react_1.default.createElement(CustomText_1.default, { weight: weight ? '300' : '600', style: [styles.defaultText, textStyle] }, title))));
};
const styles = react_native_1.StyleSheet.create({
    defaultButton: {
        borderRadius: (0, scale_1.scale)(10),
        backgroundColor: "#287BCF",
        paddingVertical: (0, scale_1.scale)(13),
        justifyContent: "center",
        alignItems: "center",
    },
    defaultText: {
        color: "white",
        fontSize: (0, scale_1.moderateScale)(16),
        fontWeight: "bold",
        lineHeight: (0, scale_1.moderateScale)(24),
    },
});
exports.default = SimpleButton;
